const DEFAULT_TIMEOUT_MS = 60000;

const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_MORFEUSZ_4E_API_URL;
  const cleanEnvUrl = String(envUrl || "").trim().replace(/\/$/, "");
  if (cleanEnvUrl) return cleanEnvUrl;

  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}/wp-json/morfeusz/v1`;
  }

  return "";
};

const withTimeout = async (promise, timeoutMs = DEFAULT_TIMEOUT_MS) => {
  let timeoutId;
  const timeout = new Promise((_, reject) => {
    timeoutId = window.setTimeout(() => reject(new Error("request_timeout")), timeoutMs);
  });

  try {
    return await Promise.race([promise, timeout]);
  } finally {
    window.clearTimeout(timeoutId);
  }
};

const normalizeError = (error) => ({
  ok: false,
  code: error?.message === "request_timeout" ? "request_timeout" : "network_error",
  message: error?.message === "request_timeout"
    ? "Morfeusz nie odpowiedział na czas. Spróbuj za chwilę."
    : "Nie udało się połączyć z Morfeuszem. Spróbuj za chwilę.",
});

export const guestDreamClient = Object.freeze({
  isConfigured: () => Boolean(getApiBaseUrl()),
  analyze: async ({ dreamText, lang = "pl" }) => {
    const baseUrl = getApiBaseUrl();
    if (!baseUrl) {
      return {
        ok: false,
        code: "not_configured",
        message: "Darmowa interpretacja AI nie jest jeszcze skonfigurowana.",
      };
    }

    try {
      const response = await withTimeout(fetch(`${baseUrl}/guest/analyze`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ dreamText, lang }),
      }));

      const data = await response.json().catch(() => null);
      if (!response.ok || !data?.ok) {
        return {
          ok: false,
          code: data?.code || "backend_error",
          message: data?.message || "Nie udało się wykonać darmowej interpretacji.",
          status: response.status,
          remainingSeconds: data?.remainingSeconds || 0,
        };
      }

      return data;
    } catch (error) {
      return normalizeError(error);
    }
  },
});
